import React from "react";
import { useField } from "formik";
import Styles from "./SignupForm.module.css";

function CustomCheckbox({ label, message, ...props }) {
	const [field, meta] = useField(props);
	// useField(props): This is a hook provided by Formik that returns an array with two elements,
	// [field, meta].It's designed to be used for managing form fields within a Formik form.

	// field :name,onChange,onBlur,aand value
	// meta:error,initialError,touched,initialTouched and valuefor input
	return (
		<>
			<div className='checkbox'>
				<input
					{...field}
					{...props}
					className={
						meta.touched && meta.error
							? Styles.inputError
							: ""
					}
				/>
				<span>{message}</span>
				{meta.touched && meta.error && (
					<div className={Styles.error}>{meta.error}</div>
				)}
			</div>
		</>
	);
}

export default CustomCheckbox;
